// Reaproveitado tambem pela aba de remessas emitidas.
export function Campo({ label, children }) {
	return (
		<div className="flex flex-col gap-1">
			<label className="text-xs font-medium text-gray-500">{label}</label>
			{children}
		</div>
	);
}

export default function FiltroBusca({
	dtIni,
	setDtIni,
	dtFim,
	setDtFim,
	nomeCliente,
	setNomeCliente,
	idVenda,
	setIdVenda,
	carregando,
	onBuscar,
}) {
	return (
		<div className="shrink-0 bg-white border border-gray-300 rounded-md p-4 flex flex-wrap items-end gap-4">
			<Campo label="Vencimento de">
				<input
					type="date"
					value={dtIni}
					onChange={(e) => setDtIni(e.target.value)}
					className="border border-gray-300 rounded px-3 py-2 text-sm"
				/>
			</Campo>

			<Campo label="ate">
				<input
					type="date"
					value={dtFim}
					onChange={(e) => setDtFim(e.target.value)}
					className="border border-gray-300 rounded px-3 py-2 text-sm"
				/>
			</Campo>

			<Campo label="Cliente">
				<input
					type="text"
					value={nomeCliente}
					placeholder="Nome do cliente (opcional)"
					onChange={(e) => setNomeCliente(e.target.value)}
					onKeyDown={(e) => e.key === "Enter" && onBuscar(1)}
					className="border border-gray-300 rounded px-3 py-2 text-sm w-64"
				/>
			</Campo>

			<Campo label="Venda">
				<input
					type="text"
					inputMode="numeric"
					value={idVenda}
					placeholder="Nº da venda"
					// So digito: o backend faz StrToInt no valor e estoura com letra.
					onChange={(e) => setIdVenda(e.target.value.replace(/\D/g, ""))}
					onKeyDown={(e) => e.key === "Enter" && onBuscar(1)}
					className="border border-gray-300 rounded px-3 py-2 text-sm w-32"
				/>
			</Campo>

			<button
				onClick={() => onBuscar(1)}
				disabled={carregando}
				className="px-4 py-2 rounded-md text-sm font-medium bg-customBlue-primary text-white hover:bg-customBlue-secondary disabled:bg-gray-300 disabled:text-gray-500"
			>
				{carregando ? "Buscando..." : "Buscar"}
			</button>
		</div>
	);
}
